import React from 'react';

// Formik validation
import { useFormik } from "formik";
import { Form, FormFeedback, Input} from 'reactstrap';
import * as Yup from "yup";
import { BaseCustomButton, BaseCustomModal, BaseCustomInput, GradientDecorationLine, BaseSelectComponent, DateUtil } from '../../../../../shared';

export const NewRegisterTestModal = ({ props, setShowModal, showModal, modalRespInfo, modalClose, modalHeader, isUpdate, rowInfo, selectorArray, icon }) => {

    let options = []
    selectorArray?.forEach(element => {
        options.push(
            {
                name: element.toString(),
                id: element.toString(),
            }
        )
    });

    const digitsOnlyPositive = (value) => {
        return /^\d+$/.test(value) && value > 0;
    };
 
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            // /* code: isUpdate ? rowInfo.code : '', */ // TODO: Revisar con Gabriel si este valor si esta bien
            sample: isUpdate ? rowInfo.sample?.split(',') : [], // TODO: Cambiar este valor para probar
            datedAt: isUpdate ? DateUtil.formatYYYYMMDD(rowInfo?.datedAt) : '',
            documentation: isUpdate ? rowInfo.documentation : '',
            comments: isUpdate ? rowInfo.comments : '',
        },
        validationSchema: Yup.object({
            documentation: Yup.string().required("Defina la documentación soporte"),
            comments: Yup.string().required("Defina los comentarios de ensayo"),
            datedAt: Yup.string().required("Defina la fecha de ejecución"),
            sample: Yup.array().required("Seleccione al menos una muestra"),
        }),
        onSubmit: (values, { resetForm }) => {
            const arr = [ ...values.sample ]
            
            const values1 = {
                ...values,
                sample: arr.join(',')
            }
            console.log('values NewRegisterTestModal: ', values1);
            modalRespInfo(values1);
            resetForm();
            setShowModal(false);
        }
    });

    const onClosed = () => {
        // setRowTestIds();
        validation.resetForm();
        modalClose();
        setShowModal(false);
    }

    const setValue = (val) => {
        validation.setFieldValue('sample',val)
    }

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color="success"
                label="Guardar"
                onClick={validation.handleSubmit}
                outline
                className="rounded-3 me-3 p-2"
                icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
                color="danger"
                label="Cancelar"
                onClick={onClosed}
                outline
                className="rounded-3 p-2"
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    const children = (
        <Form
            className="form-horizontal mt-3 mb-1"
            onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
            }}
        >
            <GradientDecorationLine />

            <div className='px-4 mx-3 mb-4'>
                {
                    isUpdate
                        ?
                        <>
                            <label className='text-primary'>Muestras -</label>
                            <BaseSelectComponent
                                placeholder="Seleccione Muestra..."
                                options={options.map((opt) => ({
                                    value: opt.id,
                                    label: opt.name,
                                }))}
                                mode="multiple"
                                value={validation.values.sample || ''}
                                onChange={(val) => {
                                    setValue(val);
                                }}
                                onBlur={() => validation.setTouched("sample", true)}
                                error={validation.errors.sample}
                                touched={validation.touched.sample}
                                />
                        </>
                        :
                        <>
                            <label className='text-primary'>Muestras</label>
                            <BaseSelectComponent
                                placeholder="Seleccione Muestra..."
                                options={options.map((opt) => ({
                                    value: opt.id,
                                    label: opt.name,
                                }))}
                                mode="multiple"
                                value={validation.values.sample || ''}
                                onChange={(val) => {
                                    setValue(val);
                                }}
                                error={validation.errors.sample}
                                touched={validation.touched.sample}
                            />
                        </>
                }
            </div>

            <div className='px-4 mx-3 mb-4'>
                <label className='text-primary'>Fecha de ejecución</label>
                <Input
                    name="datedAt"
                    required
                    className="form-control text-primary text-center rounded-3 w-100"
                    type="date"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.datedAt || ""}
                    invalid={validation.touched.datedAt && validation.errors.datedAt ? true : false}
                />
                {validation.touched.datedAt && validation.errors.datedAt ? (
                    <FormFeedback type="invalid">{validation.errors.datedAt}</FormFeedback>
                ) : null}
            </div>

            <div className='px-4 mx-3 mb-4'>
                <label className='text-primary'>Documentación Soporte</label>
                <Input
                    name="documentation"
                    className="form-control text-primary text-center rounded-3 w-100"
                    placeholder="Link de google drive"
                    type="text"
                    onChange={validation.handleChange}
                    value={validation.values.documentation || ""}
                />
                {validation.touched.documentation && validation.errors.documentation ? (
                    <FormFeedback type="invalid">{validation.errors.documentation}</FormFeedback>
                ) : null}
            </div>

            <div className='px-4 mx-3 mb-4'>
                <label className='text-primary'>Comentarios de Ensayo</label>
                <Input
                    name="comments"
                    className="form-control text-primary text-center rounded-3 w-100"
                    placeholder="Comentarios de ensayo"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.comments || ""}
                    invalid={validation.touched.comments && validation.errors.comments ? true : false}
                />
                {validation.touched.comments && validation.errors.comments ? (
                    <FormFeedback type="invalid">{validation.errors.comments}</FormFeedback>
                ) : null}
            </div>

            <GradientDecorationLine />

            {buttons}
        </Form>
    );

    const modalTitle = icon === 'warning' 
    ? (
        <div className='d-flex align-items-center justify-content-center'>
            <span className="mdi mdi-alert-outline mdi-36px text-warning ps-4 m-0"></span>
            <h4 className='text-primary m-0 ps-1'>{modalHeader}</h4>
        </div>
    )
    : <h4 className='text-primary ps-4 m-0'>{modalHeader}</h4>;

    return (
        <BaseCustomModal
            title={modalTitle}
            isModalOpen={showModal}
            handleOk={validation.handleSubmit}
            handleCancel={onClosed}
            children={children}
            footer={null}
        />
    )
}
